/** Whether the sidebar's fold is moving the page, so layout that follows the page's width can hold still until it lands. */
let isFolding = false;
const foldEndListeners = new Set<() => void>();

export const isNavFolding = () => isFolding;

export const setNavFolding = (folding: boolean) => {
  if (folding === isFolding) return;
  isFolding = folding;
  if (!folding) {
    for (const listener of foldEndListeners) listener();
  }
};

/** Calls the listener each time a fold lands; returns its removal. */
export const onNavFoldEnd = (listener: () => void) => {
  foldEndListeners.add(listener);
  return () => {
    foldEndListeners.delete(listener);
  };
};
